export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9880.c0648619.jpg";